import { useMemo, memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BreadcrumbsContainer,
  Breadcrumbs,
  useSnackbar,
  useTranslations,
  usePubSub,
} from '@uniqkey-frontend/shared-app';
import PageRouteEnum from '../../../../enums/PageRouteEnum';
import PubSubEventEnum from '../../../../enums/PubSubEventEnum';
import { useGetGroupById } from '../../../../hooks/reactQuery';

interface IGroupPageBreadcrumbsProps {
  groupId: string;
}

const GroupPageBreadcrumbs = (props: IGroupPageBreadcrumbsProps) => {
  const { groupId } = props;
  const { t } = useTranslations();
  const navigate = useNavigate();
  const { showError } = useSnackbar();

  const { data: group, isLoading, refetch } = useGetGroupById(
    { groupId },
    {
      onError: () => {
        showError({ text: t('common.somethingWentWrong') });
        navigate(PageRouteEnum.Groups);
      },
    },
  );

  const handleRefetch = useCallback(() => refetch(), [refetch]);
  usePubSub(PubSubEventEnum.DATA_SYNCHRONIZATION_GROUP, handleRefetch);

  const breadcrumbsNodes = useMemo(() => {
    if (isLoading || !group) {
      return [];
    }
    return [
      { title: t('navigation.groups'), onClick: () => navigate(PageRouteEnum.Groups) },
      { title: group.name },
    ];
  }, [isLoading, group, navigate, t]);

  return (
    <BreadcrumbsContainer>
      <Breadcrumbs
        nodes={breadcrumbsNodes}
        isLoading={isLoading}
      />
    </BreadcrumbsContainer>
  );
};

export default memo(GroupPageBreadcrumbs);
